import React from "react"
import * as api from "../api"
import * as v2layouts from "../layouts"
import { AssetCard } from "./card"

interface AssetGridProps {
	assets: api.AssetExtract[]
	selectedAssets: Set<string>
	onSelectAsset: (id: string) => void
	onApprove: (id: string) => Promise<void>
	onReject: (id: string) => Promise<void>
	onConfigure: (id: string, config: api.AssetConfigureRequest) => Promise<void>
}

export function AssetGrid({
	assets,
	selectedAssets,
	onSelectAsset,
	onApprove,
	onReject,
	onConfigure,
}: AssetGridProps): JSX.Element {
	return (
		<v2layouts.GridContainer>
			{assets.map((asset) => (
				<AssetCard
					key={asset.id}
					asset={asset}
					isSelected={selectedAssets.has(asset.id)}
					onSelect={() => onSelectAsset(asset.id)}
					onApprove={() => onApprove(asset.id)}
					onReject={() => onReject(asset.id)}
					onConfigure={(config) => onConfigure(asset.id, config)}
				/>
			))}
		</v2layouts.GridContainer>
	)
}
